export default class ProcessStep {
    Name:string|null = null;
    StepType:string|null = null;
}